import { Injectable } from '@angular/core';
import{LoginResponse} from '../../models/login/login'
import { HttpClient,HttpParams, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
// import { RequestOptions } from '@angular/http';
import {Observable,throwError,BehaviorSubject } from 'rxjs';
import {catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private upcommingEventUrl: string;
  private logOutURL: string;
  private addBlockDatesUrl:string;
  private getBlockDatesUrl:string;
  filter={"brandId":"1","speakerId":"25"}
  private eventDetailsUrl:string;
  constructor(private http: HttpClient) { 
    this.upcommingEventUrl = environment.apiUrl + '/api/Speaker/Dashboard/events';
    this.eventDetailsUrl=environment.apiUrl+'/patientspeaker/events/'
    this.logOutURL=environment.apiUrl + '/logout';
    this.getBlockDatesUrl=environment.apiUrl + '/patientspeaker/scheduling/getAll?';
    this.addBlockDatesUrl=environment.apiUrl+'/patientspeaker/scheduling/add'
  }
  getUpcommingEvent(filterObj){
    return this.http.post(this.upcommingEventUrl,(JSON.stringify(filterObj))); 
  }
  getEventDetails(eventId){
    return this.http.get(this.eventDetailsUrl+eventId)
    // return this.http.post()
  }
  getAllBlockDates(filterObj){
    return this.http.get(this.getBlockDatesUrl+'filter='+encodeURIComponent(JSON.stringify(filterObj)))
 }
  addBlockDates(filterObj){
    const httpOptions = {
      headers: new HttpHeaders({
      'Content-Type':  'application/json'
      }),
      };
    return this.http.post(this.addBlockDatesUrl,(JSON.stringify(filterObj)),httpOptions)
  }
 

}
